import type { FilledGroupInfo, PlanningEntity } from '@/components/contentContainers/PlanningContainer.tsx';
import type { ObjectBoxInfo, TuneControlInfo } from '@/engine/app/models/viewEntity/view.entity.ts';
import type {
  MeasurementBoxProps
} from '@/components/boxes/measurementBoxes/MeasurementBoxesController/MeasurementBoxes.controller.ts';
import { GroupKind } from '@/engine/app/interfaces.ts';

export function isGroupKind(entity: PlanningEntity | FilledGroupInfo): entity is FilledGroupInfo {
  return entity.kind in GroupKind;
}

export function isObjectBox(box: PlanningEntity): box is ObjectBoxInfo {
  return 'objects' in box;
}

export function isMeasurementBox(box: PlanningEntity): box is MeasurementBoxProps {
  return 'measurements' in box;
}

export function isTuneControl(control: PlanningEntity): control is TuneControlInfo {
  return 'units' in control;
}

export function isResetTuneControl(descriptor: Array<string> | string): descriptor is Array<string> {
  return Array.isArray(descriptor);
}

export function isSingularTuneControl(descriptor: Array<string> | string): descriptor is string {
  return typeof descriptor === 'string';
}

